export const EMAIL_LANGS = [
  { code: "", label: "SK + DE (pôvodný)" },
  { code: "sk", label: "SK 🇸🇰" },
  { code: "en", label: "EN 🇬🇧" },
  { code: "de", label: "DE 🇩🇪" },
  { code: "pl", label: "PL 🇵🇱" },
  { code: "fr", label: "FR 🇫🇷" },
];

export const pickEmailLang = (l) => (EMAIL_LANGS.some((x) => x.code && x.code === l) ? l : "");

export const EmailLangPicker = ({ value, onChange, testid = "email-lang" }) => (
  <div data-testid={`${testid}-picker`}>
    <label className="block text-xs uppercase tracking-wider text-white/40 mb-2">Jazyk e-mailu (oslovenie, podpis, pätička)</label>
    <div className="flex flex-wrap gap-1.5">
      {EMAIL_LANGS.map((l) => (
        <button key={l.code || "mixed"} type="button" onClick={() => onChange(l.code)} data-testid={`${testid}-${l.code || "mixed"}`}
          className={`px-3 py-1.5 text-xs border transition-colors ${value === l.code ? "border-[#D4AF37] bg-[#D4AF37]/15 text-[#D4AF37]" : "border-white/15 text-white/60 hover:border-[#D4AF37]/50 hover:text-white"}`}>
          {l.label}
        </button>
      ))}
    </div>
    <p className="text-white/30 text-[11px] mt-1.5">Text správy píšete sami — v zvolenom jazyku budú iba pevné popisy šablóny.</p>
  </div>
);
